// Indian states and union territories from country-state-city (comprehensive list)
import { State } from 'country-state-city';

const INDIA_CODE = 'IN';

const statesList = State.getStatesOfCountry(INDIA_CODE);

/** All Indian states and union territories (names), sorted alphabetically */
export const INDIAN_STATES = statesList
  .map((s) => s.name)
  .filter(Boolean)
  .sort((a, b) => a.localeCompare(b));

/** Get state ISO code by name (e.g. "Tamil Nadu" -> "TN") */
export const getStateCodeByName = (stateName) => {
  const state = statesList.find((s) => s.name === stateName);
  return state ? state.isoCode : null;
};
